//--------------------
// create api request
//--------------------
export default function createAPIRequest(request_parms) {

  let request = {
    endpoint: "",
    method: "",
  };

  if (request_parms.slug !== undefined && 
    request_parms.slug !== null && 
    request_parms.slug !== "") {
    request.endpoint = `${request_parms.endpoint}` + `${request_parms.slug}/`;
    //
    if (request_parms.partialInd) {
      request.method = "PATCH";
    } else if (request_parms.deleteInd) {
      request.method = "DELETE";
    } else {
      request.method = "PUT";
    }
  } else {
    request.endpoint = request_parms.endpoint;
    request.method = "POST";
  }
  return request;
}
